// @ts-ignore
import { tw } from "@careinfo/tailwind";
const SettingsTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div
      className={tw`flex items-center px-6 py-4 bg-white border-b border-gray-200`}
    >
      <div className={tw`flex gap-2`}>
        <button
          onClick={() => setActiveTab("profile")}
          className={tw`px-6 py-2.5 rounded-lg font-medium transition-all focus:outline-none ${
            activeTab === "profile"
              ? "bg-red-500 text-white shadow-md"
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
        >
          Profile
        </button>
        <button
          onClick={() => setActiveTab("signature")}
          className={tw`px-6 py-2.5 rounded-lg font-medium transition-all focus:outline-none ${
            activeTab === "signature"
              ? "bg-red-500 text-white shadow-md"
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
        >
          Signature
        </button>
      </div>
    </div>
  );
};

export default SettingsTabs;
